import { useState, useEffect } from 'react';
import { Trash2 } from 'lucide-react';
import api from '../../api/api';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
  setLoading(true);
  try {
    const res = await api.get('/users');

    // Filter out the email you don't want
    const filteredUsers = res.data.filter(
      (user) => user.email !== "naolberhanu06@gmail.com"
    );

    setUsers(filteredUsers);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};


  const handleRoleChange = async (userId, newRole) => {
    try {
      await api.put(`/users/${userId}/role`, { role: newRole });
      setUsers((prev) =>
        prev.map((u) => (u.id === userId ? { ...u, role: newRole } : u))
      );
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm("Are you sure? This will also delete all their bookings.")) return;

    try {
      await api.delete(`/users/${userId}`);
      setUsers((prev) => prev.filter((u) => u.id !== userId));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="  ">
      {/* Header */}
      <div className="mb-6 flex items-center justify-between flex-wrap">
        <h2 className="text-2xl font-bold text-gray-800 dark:text-white">Manage Users</h2>
        <p className="text-gray-600 dark:text-gray-300 text-sm">
          Total Users: <span className="font-semibold">{users.length}</span>
        </p>
      </div>

      {/* Loading */}
      {loading ? (
        <div className="text-center py-10 text-gray-500 dark:text-gray-300 font-semibold">
          Loading...
        </div>
      ) : (
        <>
          {/* Desktop Table */}
          <div className="hidden md:block overflow-x-auto rounded-lg border border-gray-200 dark:border-slate-700 shadow-sm">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-100 dark:bg-slate-700">
                <tr>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 dark:text-gray-200 border-b">ID</th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 dark:text-gray-200 border-b">Name</th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 dark:text-gray-200 border-b">Email</th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 dark:text-gray-200 border-b">Role</th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 dark:text-gray-200 border-b">Joined</th>
                  <th className="px-4 py-3 text-center font-semibold text-gray-700 dark:text-gray-200 border-b">Actions</th>
                </tr>
              </thead>

              <tbody>
                {users.map((user) => (
                  <tr key={user.id} className="hover:bg-gray-50 dark:hover:bg-slate-700 transition">
                    <td className="px-4 py-3 border-b dark:border-slate-600">#{user.id}</td>
                    <td className="px-4 py-3 border-b dark:border-slate-600 font-semibold text-gray-800 dark:text-white">
                      {user.name}
                    </td>
                    <td className="px-4 py-3 border-b dark:border-slate-600 text-gray-600 dark:text-gray-300">
                      {user.email}
                    </td>

                    <td className="px-4 py-3 border-b dark:border-slate-600">
                      <select
                        value={user.role}
                        onChange={(e) => handleRoleChange(user.id, e.target.value)}
                        className="px-3 py-2 border rounded-lg text-sm bg-white dark:bg-slate-800 border-gray-300 dark:border-slate-600 focus:ring-2 focus:ring-blue-400 outline-none"
                      >
                        <option value="user">User</option>
                        <option value="admin">Admin</option>
                      </select>
                    </td>

                    <td className="px-4 py-3 border-b dark:border-slate-600 text-gray-600 dark:text-gray-300">
                      {new Date(user.created_at).toLocaleDateString()}
                    </td>

                    <td className="px-4 py-3 border-b dark:border-slate-600 text-center">
                      <button
                        className="p-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition"
                        onClick={() => handleDeleteUser(user.id)}
                      >
                        <Trash2 size={18} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-4">
            {users.map((user) => (
              <div
                key={user.id}
                className="p-4 bg-gray-50 dark:bg-slate-700 rounded-xl border border-gray-200 dark:border-slate-600 shadow-sm"
              >
                <div className="flex justify-between">
                  <h3 className="font-bold text-gray-800 dark:text-white">{user.name}</h3>
                  <button
                    className="p-2 bg-red-500 hover:bg-red-600 text-white rounded-lg"
                    onClick={() => handleDeleteUser(user.id)}
                  >
                    <Trash2 size={16} />
                  </button>
                </div>

                <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">{user.email}</p>

                <div className="mt-3 text-sm">
                  <p className="text-gray-700 dark:text-gray-200 mb-1">
                    Joined: {new Date(user.created_at).toLocaleDateString()}
                  </p>

                  <select
                    value={user.role}
                    onChange={(e) => handleRoleChange(user.id, e.target.value)}
                    className="mt-2 w-full px-3 py-2 border rounded-lg text-sm bg-white dark:bg-slate-800 border-gray-300 dark:border-slate-600 focus:ring-2 focus:ring-blue-400 outline-none"
                  >
                    <option value="user">User</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
